if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.error = false;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname + window.location.search);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const bundleVariants = document.querySelectorAll('.bundle-variants');

      // =================================================
      // LÓGICA COM BUNDLE (MOLDURAS/FRAMES)
      // =================================================
      if (bundleVariants.length > 0) {
        let uniqueId = document.querySelector('#unique-id').value;
        let variantIds = document.querySelector('#variant-ids').value;
        let items = [];
        
        bundleVariants.forEach(variant => {
           // Verifica se tem valor selecionado para não enviar vazio
           if(variant.value) {
              items.push({
                'id': variant.value,
                'quantity': document.querySelector('[name="quantity"]').value,
                'properties': {
                  'ID': uniqueId,
                  "_bundleVariants": variantIds
                }
              });
           }
        })

        let data = { 'items': items }

        // Gera novo ID único para a próxima compra
        document.querySelector('#unique-id').value = Array.from(Array(6), () => Math.floor(Math.random() * 36).toString(36)).join('');
        
        // 1. Adiciona os itens do bundle (moldura)
        const frameAdd = items.length ? fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        }).then(async response => {
          const result = await response.json();
          if (!response.ok || result.status) {
            const error = new Error('FRAME_ADD_FAILED');
            error.cartMessage = result.description || result.message;
            throw error;
          }
          return result;
        }) : Promise.resolve();
        frameAdd.then(() => {
          // 2. Adiciona o produto principal e atualiza o carrinho
          return fetch(`${routes.cart_add_url}`, config);
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
            this.error = false;
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.renderCart(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              return this.renderCart(response);
            }
        })
        .catch((e) => {
            console.error(e);
            this.handleErrorMessage(e.cartMessage || window.cartStrings?.error || 'We couldn’t confirm your cart update. Please check your cart before trying again.');
        })
        .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

            const dummyButtons = document.querySelectorAll('.add-to-cart');
            dummyButtons.forEach((button) => {
              button.classList.remove('loading');
            });
        });

      } else {
        // =================================================
        // LÓGICA PADRÃO (SEM BUNDLE)
        // =================================================
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCart(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            return this.renderCart(response);
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage(e.cartMessage || window.cartStrings?.error || 'We couldn’t confirm your cart update. Please check your cart before trying again.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
      }
    }

    renderCart(response) {
      return Promise.resolve().then(() => this.cart.renderContents(response)).catch(error => {
        console.error(error);
        this.handleErrorMessage('Your item was added, but the cart could not be displayed. Please open your cart to check it.');
      });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper && errorMessage) {
        this.errorMessageWrapper = document.createElement('div');
        this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
        this.errorMessageWrapper.setAttribute('role', 'alert');
        const message = document.createElement('span');
        message.className = 'product-form__error-message';
        this.errorMessageWrapper.appendChild(message);
        this.form.prepend(this.errorMessageWrapper);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
